// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="these-apis-allow-verification-of-veteran-status-and-maintenance-of-some-profile-data.-they-return-service-history-confirm-veteran-status%2C-update-veteran-address-and-benefit-payment-details%2C-and-validate-addresses.">These APIs allow verification of Veteran status and maintenance of some profile data. They return service history, confirm Veteran status, update Veteran address and benefit payment details, and validate addresses.</h2>
      <p>We’re giving Veterans better control of and access to their information – including their service history, Veteran status, discharge information, and more by working with government agencies and industry partners to help Veterans put their information to work. <Link to="/release-notes/verification">Review the latest release notes</Link>.</p>
    </div>
  );
};

export default MarkdownComponent;
